import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

/**
 * TEMPORARY sink. Posts aggregated telemetry to the existing AV client-log endpoint so sessions
 * produce queryable signal before the durable path lands; the uploader (294677) plus ingest
 * (294679) replace it. Deleting this service and its call sites should be the whole removal.
 *
 * The route is Chime-named for historical reasons, and wrapped here rather than reached through
 * `chime/ChimeService` so av-telemetry keeps no Chime dependency.
 */
@Injectable({ providedIn: 'root' })
export class AvTelemetryLogService {
  static readonly WARNING_LOG_ROUTE = 'videoConferenceMonitoring/sendChimeClientWarningLog';

  constructor(private readonly httpClient: HttpClient) {}

  /** Correlation headers are added by BaseUrlInterceptor, so the body carries metrics only. */
  send(message: string): Observable<unknown> {
    return this.httpClient.post<unknown>(AvTelemetryLogService.WARNING_LOG_ROUTE, {
      message: message,
    });
  }
}
